import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';

const RadioSelector = ({ options = [], value = '', onChange = () => {}, label, placeholder = 'Selecione', disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) setIsOpen(prev => !prev);
  };

  const handleSelect = (optValue, e) => {
    e.stopPropagation();
    if (disabled) return;
    onChange(optValue);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const displayText = value
    ? (options.find(o => o.value === value)?.label || placeholder)
    : placeholder;

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      {label && <label>{label}</label>}
      <div className={`${styles.selectWrapper}${isOpen ? ` ${styles.active}` : ''}${disabled ? ` ${styles.disabled}` : ''}`}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span className={value ? styles.selectedText : styles.placeholderText}>{displayText}</span>
          <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
        </div>
        <div className={styles.radioList}>
          {options.map((option) => (
            <label
              key={option.value}
              className={styles.radioItem}
              onClick={e => e.stopPropagation()}
            >
              <input
                type="radio"
                name={`radio-selector-${label}`}
                value={option.value}
                checked={value === option.value}
                onChange={(e) => handleSelect(option.value, e)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RadioSelector;
